import { useFetch } from "@app/framework/hooks";
import fileImg from "@assets/images/file.png";
import { GeneralAssemblyForm } from "@modules/general-assembly/types";
import { Loading, NoDataFound } from "@modules/shared/components";
import { getLocalizedValue } from "@modules/shared/utils";
import { trans } from "@mongez/localization";
import { useEffect, useId } from "react";

type Data = {
  generalAssemblyForms: GeneralAssemblyForm[];
};

export function FormsTab() {
  const { data, load, isLoading } = useFetch<Data>(
    "/investor-relations/general-assembly/forms",
  );

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="flex animate-fade flex-col gap-6 rounded-3xl bg-white p-4 md:gap-8 md:p-8">
      {/* <FancyBox> */}
      {isLoading ? (
        <Loading />
      ) : (
        <div className="grid grid-cols-[repeat(auto-fill,minmax(230px,1fr))] gap-6">
          {data && data.generalAssemblyForms ? (
            data.generalAssemblyForms.map((form) => (
              <FormItem key={form.id} form={form} />
            ))
          ) : (
            <NoDataFound />
          )}
        </div>
      )}
      {/* </FancyBox> */}
    </div>
  );
}

type FormItemProps = {
  form: GeneralAssemblyForm;
};

function FormItem({ form }: FormItemProps) {
  const id = useId();

  return (
    <a
      data-fancybox="general-assembly-forms"
      data-src={getLocalizedValue(form.file)}
      href={getLocalizedValue(form.file)}
      target="_blank"
      rel="noopener noreferrer"
      className="group flex cursor-pointer flex-col items-center gap-4 rounded-2xl border border-[#E0E0E0] bg-white p-4 shadow-sm transition-colors duration-300 hover:bg-gray-100"
    >
      {/* <a
        data-fancybox="general-assembly-forms"
        data-src={getLocalizedValue(form.file)}
        href={getLocalizedValue(form.file)}
        target="_blank"
        rel="noopener noreferrer"
        className="h-64 shrink-0 overflow-hidden rounded-xl"
      >
        <img
          src={form.image?.url || formImg}
          alt={form.image?.name || "form-image"}
          width={180}
          height={250}
          className="h-full w-full object-cover transition-all duration-300 group-hover:scale-105"
        />
      </a> */}
      {/* <div className="flex size-20 items-center justify-center">
        <img src={fileImg} alt="file" className="mt-5 size-10" />
      </div> */}

      <div className="flex flex-col gap-2">
        <p className="text-center font-semibold text-marine">
          {trans(form.title)}
        </p>
        <div className="flex items-center justify-center gap-2 text-sm text-secondary">
          <p>{form.year}</p>
        </div>
      </div>
    </a>
  );
}
